import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { RequireAuth } from '@/auth/RequireAuth'
import { CallbackPage } from '@/routes/CallbackPage'
import { LobbyPage } from '@/routes/LobbyPage'
import { NotFoundPage } from '@/routes/NotFoundPage'
import { SignedOutPage } from '@/routes/SignedOutPage'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <LobbyPage />
            </RequireAuth>
          }
        />
        <Route path="/callback" element={<CallbackPage />} />
        <Route path="/signed-out" element={<SignedOutPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}
